<template>
  <div>
    <!-- <div class="headline primary--text">สถานะ Voucher</div> -->
    <v-layout row justify-end class="mt-2">
      <v-flex xs3>
        <div class="form-control" style="margin-right: 6px">
          <date-picker
            :append-to-body="false"
            :clearable="true"
            :editable="false"
            input-class="dateSearch"
            name="DateSearch"
            v-model="filter.dateFrom"
            valueType="date"
            format="DD/MM/YYYY"
            :placeholder="$t('เลือกวันที่เริ่ม')"
            confirm
            @change="onSearch"
          >
            <template v-slot:footer="{ emit }">
              <div style="text-align: left">
                <button class="mx-btn mx-btn-text" @click="emit(new Date())">Today</button>
              </div>
            </template>
          </date-picker>
        </div>
      </v-flex>
      <v-flex xs3 class="ml-1">
        <div class="form-control" style="margin-right: 6px">
          <date-picker
            @change="onSearch"
            :append-to-body="false"
            :clearable="true"
            :editable="false"
            input-class="dateSearch"
            name="DateSearch"
            v-model="filter.dateTo"
            valueType="date"
            format="DD/MM/YYYY"
            :placeholder="$t('เลือกวันที่สิ้นสุด')"
            confirm
          >
            <template v-slot:footer="{ emit }">
              <div style="text-align: left">
                <button class="mx-btn mx-btn-text" @click="emit(new Date())">Today</button>
              </div>
            </template>
          </date-picker>
        </div>
      </v-flex>

      <v-flex xs6 class="ml-1">
        <multiselect
          v-model="filter.campaign"
          :options="campaign"
          label="campaignname"
          selectLabel
          selectedLabel
          placeholder="แคมเปญ"
          @change="onSearch"
          deselect-label
        ></multiselect>
      </v-flex>
    </v-layout>
    <InputSearch
      class="mb-3"
      :search="filter"
      @clickSearch="onSearch"
      :placeholder="'ค้นหา ชื่อหน่วยร่วม'"
    />

    <v-layout
      wrap
      class="mt-4"
      style="display: flex; justify-content: space-between; align-items: center"
    >
      <v-flex xs6>
        <Typography h2 bold label="สถานะคูปอง" />
      </v-flex>

      <v-flex xs6 class="text-xs-right">
        <v-btn
          variant="outlined"
          v-tooltip="'ส่งออกข้อมูล'"
          @click="modalExport = true"
          :loading="loading"
          icon
          color="#BECCDB"
          style="border-radius: 50% !important"
        >
          <img src="/static/img/exportfilter.png" alt class="responsive-img" style="height: 16px" />
        </v-btn>
      </v-flex>
    </v-layout>

    <div>
      <v-layout class="my-5" justify-center v-if="loading">
        <v-progress-circular
          :size="100"
          :width="10"
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-layout>
      <v-data-table
        v-else
        :loading="loading"
        :headers="headers"
        :items="showData"
        hide-actions
        item-key="name"
      >
        <template v-slot:items="props">
          <tr class="py-3 depatable">
            <td class="text-xs-left"><Typography h5 :label="props.item.agencyname" /></td>
            <td class="text-xs-left">
              <Typography h5 color="color-waiting" :label="props.item.status['รอตรวจสอบ'] || 0" />
            </td>
            <td class="text-xs-left">
              <Typography h5 color="color-waiting" :label="props.item.status['รอเอกสาร'] || 0" />
            </td>
            <td class="text-xs-left">
              <Typography h5 color="color-waiting" :label="props.item.status['แก้ไขเอกสาร'] || 0" />
            </td>
            <td class="text-xs-left">
              <Typography h5 color="color-complete" :label="props.item.status['อนุมัติ'] || 0" />
            </td>
            <td class="text-xs-left">
              <Typography h5 color="color-error" :label="props.item.status['ไม่อนุมัติ'] || 0" />
            </td>
            <td class="text-xs-left">
              <Typography h5 color="color-error" :label="props.item.status['ยกเลิก'] || 0" />
            </td>
            <td class="text-xs-left">
              <Typography h5 color="color-mediumGrey" :label="props.item.status['หมดอายุ'] || 0" />
            </td>
          </tr>
        </template>
      </v-data-table>
    </div>
    <v-dialog v-model="modalExport" persistent width="400px">
      <v-card style="border-radius: 10px">
        <div class="pa-3">
          <div style="display: flex; justify-content: space-between">
            <div></div>
            <div></div>

            <v-icon style="display: flex; align-items: center" @click="modalExport = false"
              >close</v-icon
            >
          </div>
          <div class="rsu">
            <v-layout column wrap justify-center align-center class="mb-3">
              <img
                src="/static/img/Export.png"
                alt
                class="responsive-img mb-1"
                style="height: 70px"
              />
              <Typography h2 bold label="ส่งออกข้อมูล" />
              <Typography h5 medium label="คุณแน่ใจหรือไม่ว่าต้องการส่งออกข้อมูลตามที่เลือก" />
            </v-layout>
            <div class="text-xs-center">
              <div class="text-xs-center rsu">
                <v-btn
                  :loading="searchloading"
                  class="rsu"
                  round
                  small
                  outline
                  color="primary"
                  @click.stop="modalExport = false"
                  >ยกเลิก</v-btn
                >
                <v-btn
                  class="rsu"
                  :loading="searchloading"
                  round
                  small
                  depressed
                  style="color: #ffef01"
                  color="primary"
                  @click.stop="exportxlsx()"
                  >ยืนยัน</v-btn
                >
              </div>
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <Paginations
      @clickPagination="changepage"
      @sortPage="sortPage"
      :pageCount="pageCount"
      :numberPage="numberPage"
      :page="page"
    />
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import moment from 'moment'
import api from '@/api'
import config from '@/config'
// import exportxlsx from '@/components/elements/exportxlsx.vue'
import Typography from '@/components/elements/Typography.vue'
import InputSearch from '@/components/elements/InputSearch.vue'
// import { VueDatePicker } from '@mathieustan/vue-datepicker'
import DatePicker from 'vue2-datepicker'
import Paginations from '@/components/elements/Paginations.vue'
import XLSX from 'xlsx'

export default {
  components: {
    Multiselect,
    // datepicker,
    Typography,
    InputSearch,
    // VueDatePicker,
    Paginations,
    DatePicker
  },
  data() {
    return {
      modalExport: false,
      agencyOptions: [],
      filter: {
        campaign: null,
        dateFrom: null,
        dateTo: null,
        nameAll: ''
      },
      page: 1,
      numberPage: {
        page: undefined
      },
      rowsPerPage: 12,
      pageTotal: 0,
      loading: false,
      campaign: [],
      mainData: [],
      showData: [],
      topData: [],
      top5: [],
      topOther: [],
      tafficReport: {},
      topProduct: [],
      headers: [
        { text: 'ชื่อหน่วยร่วม', align: 'left', value: 'name', sortable: false },
        { text: 'รอตรวจสอบ', align: 'left', value: '1', sortable: false },
        { text: 'รอเอกสาร', align: 'left', value: '2', sortable: false },
        { text: 'แก้ไขเอกสาร', align: 'left', value: '3', sortable: false },
        { text: 'อนุมัติ', align: 'left', value: '4', sortable: false },
        { text: 'ไม่อนุมัติ', align: 'left', value: '5', sortable: false },
        { text: 'ยกเลิก', align: 'left', value: '6', sortable: false },
        { text: 'หมดอายุ', align: 'left', value: '7', sortable: false }
      ]
    }
  },
  computed: {
    // async exportDataVoucher() {

    // },
    techhuntUrl() {
      return config.techhuntUrl
    },
    pageCount() {
      if (this.pageTotal !== 0) {
        let count = Math.ceil(this.pageTotal / this.rowsPerPage)
        return count
      } else {
        return 0
      }
    },
    limitCom() {
      return this.rowsPerPage
    },
    offsetCom() {
      return this.page ? this.page * this.rowsPerPage - this.rowsPerPage : this.rowsPerPage
    }
  },
  mounted() {
    this.setup()
  },
  methods: {
    setup() {
      this.getCampaign()
      this.gettafficReport()
      this.countCouponStatusWithFilter()
    },
    async exportxlsx() {
      let filter = {}

      if (this.filter.dateFrom) {
        filter.dateFrom = moment(this.filter.dateFrom).format('YYYY-MM-DD')
      }
      if (this.filter.dateTo) {
        filter.dateTo = moment(this.filter.dateTo).format('YYYY-MM-DD')
      }
      if (this.filter.campaign) {
        filter.campaignId = this.filter.campaign.id
      }
      if (this.filter.nameAll) {
        filter.nameAll = this.filter.nameAll
      }

      // filter.limit = this.limitCom
      // filter.offset = this.offsetCom

      let res = await api.countCouponStatusWithFilter(filter)

      for (let i = 0; i < res.data.length; i++) {
        if (res.data[i].status && res.data[i].status.length) {
          let obj = {}
          for (let j = 0; j < res.data[i].status.length; j++) {
            obj[res.data[i].status[j][0]] = res.data[i].status[j][1]
          }
          res.data[i].status = obj
        }
      }

      var result = res.data.map(el => {
        return {
          หน่วยร่วม: el.agencyname,
          รอตรวจสอบ: el.status['รอตรวจสอบ'] || 0,
          รอเอกสาร: el.status['รอเอกสาร'] || 0,
          แก้ไขเอกสาร: el.status['แก้ไขเอกสาร'] || 0,
          อนุมัติ: el.status['อนุมัติ'] || 0,
          ไม่อนุมัติ: el.status['ไม่อนุมัติ'] || 0,
          ยกเลิก: el.status['ยกเลิก'] || 0,
          หมดอายุ: el.status['หมดอายุ'] || 0
        }
      })

      const dataWS = XLSX.utils.json_to_sheet(result)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, 'exportedfile' + '.xlsx')
      this.modalExport = false
    },
    async onSearch() {
      this.page = parseInt(1)
      this.loading = true
      this.countCouponStatusWithFilter()
      this.loading = false
    },
    async getCampaign() {
      this.campaign = await api.getCampaign()
    },
    async gettafficReport() {
      this.tafficReport = await api.gettafficReport()
    },
    async getTopProduct() {
      this.topProduct = await api.getTopProduct(3)
    },
    async countCouponStatusWithFilter() {
      let filter = {}

      if (this.filter.dateFrom) {
        filter.dateFrom = moment(this.filter.dateFrom).format('YYYY-MM-DD')
      }
      if (this.filter.dateTo) {
        filter.dateTo = moment(this.filter.dateTo).format('YYYY-MM-DD')
      }
      if (this.filter.campaign) {
        filter.campaignId = this.filter.campaign.id
      }
      if (this.filter.nameAll) {
        filter.nameAll = this.filter.nameAll
      }
      filter.limit = this.limitCom
      filter.offset = this.offsetCom

      let res = await api.countCouponStatusWithFilter(filter)

      for (let i = 0; i < res.data.length; i++) {
        if (res.data[i].status && res.data[i].status.length) {
          let obj = {}
          for (let j = 0; j < res.data[i].status.length; j++) {
            obj[res.data[i].status[j][0]] = res.data[i].status[j][1]
          }
          res.data[i].status = obj
        }
      }
      this.mainData = res.data
      this.showData = res.data
      this.pageTotal = res.total
      this.loading = false
    },
    async changepage(pages) {
      this.page = parseInt(pages)
      this.numberPage.page = undefined
      this.loading = true
      await this.setup()
      this.loading = false
    },
    async sortPage(pages) {
      let count = Math.ceil(this.pageTotal / this.rowsPerPage)
      if (pages == '' || Number(pages <= 0) || pages > Number(count)) return
      if (pages) {
        this.page = parseInt(pages)
        this.loading = true
        await this.setup()
        this.loading = false
      }
    },
    openUrl(url) {
      // console.log(url)
      window.location.href = url
    }
  }
}
</script>

<style lang="scss" scoped>
.box {
  width: 120px;
  min-height: 60px;
  background-color: #182748;
  color: white;
  text-align: center;
  align-self: center;
  font-weight: bold;
}
.flex-row-end {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/components/view/voucherreport/voucherStatus.vue